import gql from "graphql-tag";
import {
  FRAGMENT_MEDIA_ITEM,
  FRAGMENT_NEIGHBORHOOD_DETAILS,
} from "./fragments.js";

export const GET_QMI = gql`
  ${FRAGMENT_MEDIA_ITEM}
  ${FRAGMENT_NEIGHBORHOOD_DETAILS}
  query GetQMI($uri: ID!) {
    home(id: $uri, idType: URI) {
      databaseId
      id
      title
      collection {
        collection
        fieldGroupName
      }
      qmiHomeDetails {
        address1
        address2
        bathrooms
        bedrooms
        brochureLink
        disclaimer
        eciLink
        finishedSqrFt
        garage
        latitude
        longitude
        mainSqrFt
        matterportTour
        matterportTourTitle
        pdfEPub
        price
        propertyDescription
        type
        elevations {
          ...MediaItemFragment
        }
        neighborhood {
          ... on Neighborhood {
            id
            slug
            title
            uri
            neighborhood {
              hours
              phone
              saleTeamMembers {
                name
                email
                image {
                  ...MediaItemFragment
                }
              }
            }
          }
        }
        floorplan {
          ... on Plan {
            databaseId
            id
            title
            uri
            floorplanDetails {
              collection
              displayTitle
              homeType
              type
              neighborhood {
                ...NeighborhoodDetailsFragment
              }
            }
          }
        }
        galleryItems {
          type
          videoUrl
          thumbnail {
            ...MediaItemFragment
          }
          image {
            ...MediaItemFragment
          }
        }
        tabs {
          title
          image {
            ...MediaItemFragment
          }
        }
      }
    }
    collectionFeatures
  }
`;
